export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '什么是流氓视频？',
    answer: '流氓视频是指含有恶意代码、强制弹窗广告、自动下载恶意软件、虚假诱导内容或侵犯用户隐私的视频内容。它们通常利用用户的好奇心或需求作为突破口，在用户观看过程中实施侵害行为，包括但不限于窃取个人信息、植入木马程序、诱导诈骗等。',
  },
  {
    question: '如何判断一个视频链接是否安全？',
    answer: '可以从以下几个方面判断：检查URL域名是否正规（避免拼写相似的假冒域名）；查看页面是否有HTTPS加密；观察页面是否存在大量异常弹窗广告；使用在线安全检测工具（如VirusTotal）扫描链接；在搜索引擎中搜索网站名称加"诈骗"关键词查看其他用户的反馈。核心原则：有任何不确定，宁可放弃观看也不要冒险点击。',
  },
  {
    question: '不小心点击了恶意视频链接怎么办？',
    answer: '首先立即关闭该页面（不要点击页面上的任何按钮，包括"关闭"按钮，直接关闭浏览器标签页或窗口）。然后运行杀毒软件进行全盘扫描；清除浏览器缓存和cookie数据；检查最近下载的文件和安装的程序，删除可疑内容；修改在该设备上登录过的重要账户密码。如果已经输入了银行卡等敏感信息，应立即联系银行冻结账户并报警。',
  },
  {
    question: '手机中病毒后有哪些症状？',
    answer: '常见症状包括：手机突然变得卡顿、发热异常；电池消耗速度明显加快；在没有操作的情况下自动弹出广告；出现不认识的应用图标；流量使用量异常增加；通话或短信记录中出现不明的记录；手机自动发送短信或拨打电话。如果出现以上情况，应备份重要数据后恢复出厂设置。',
  },
  {
    question: '遇到视频诈骗应该向哪里举报？',
    answer: '可以通过多个渠道举报：首先向所在平台举报（微信、抖音等都有举报功能）；然后可向12321网络不良与垃圾信息举报中心举报（12321.cn）；向中国互联网违法和不良信息举报中心举报（12377.cn）；如果涉及金额较大或已造成实际损失，应立即向公安机关报案（拨打110或前往派出所），也可通过国家反诈中心APP在线报案。',
  },
  {
    question: '流氓视频和普通视频广告有什么区别？',
    answer: '普通视频广告是平台明确标识的商业推广内容，通常有"广告"标签，且提供正常的关闭或跳过按钮。流氓视频的恶意行为是隐蔽的、强制性的，表现为关闭按钮无法正常工作（点击反而触发更多弹窗）、诱导用户下载不明程序、在后台静默收集数据、伪造系统警告骗取用户操作等。核心区别在于：普通广告是透明的商业行为，流氓视频是恶意的侵害行为。',
  },
  {
    question: '如何保护家中老人免受流氓视频侵害？',
    answer: '建议采取以下措施：为老人的手机设置应用安装权限限制（关闭"未知来源"安装选项）；安装可靠的安全防护软件并开启实时防护；教会老人识别常见的诈骗视频特征（如"震惊体"标题、虚假中奖信息等）；定期帮老人清理手机中的可疑应用；建立家庭群聊，鼓励老人在遇到不明链接时先询问家人再操作。关键是要用耐心的方式沟通，让老人养成"看不懂的不点、不确定的问"的良好习惯。',
  },
];